import React from 'react'
import {
  FormControlLabel,
  Switch,
  Box,
  Tooltip,
  Typography
} from '@mui/material'
import {
  Timeline as TimelineIcon
} from '@mui/icons-material'

interface TimelineDataToggleProps {
  showTimelineDataOnly: boolean
  onToggle: (enabled: boolean) => void
  disabled?: boolean
}

/**
 * Dated Initiatives Only Toggle Component
 *
 * Filters initiatives to show only those with complete timeline data
 * (both start and end dates from JIRA custom fields customfield_10534/10535)
 * and excludes paused initiatives as their timelines are no longer relevant
 */
const TimelineDataToggle: React.FC<TimelineDataToggleProps> = ({
  showTimelineDataOnly,
  onToggle,
  disabled = false
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onToggle(event.target.checked)
  }

  const tooltipText = "Show only initiatives with both start and end dates. Excludes paused initiatives."

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      py: 0.25,
      px: 1
    }}>
      <Tooltip
        title={tooltipText}
        placement="top"
      >
        <FormControlLabel
          control={
            <Switch
              checked={showTimelineDataOnly}
              onChange={handleChange}
              disabled={disabled}
              size="small"
              color="primary"
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: 'primary.main',
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: 'primary.main',
                  opacity: 0.7
                }
              }}
            />
          }
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <TimelineIcon
                fontSize="small"
                color={showTimelineDataOnly ? "primary" : "action"}
                sx={{ fontSize: 14 }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontSize: '0.8rem',
                  fontWeight: showTimelineDataOnly ? 'medium' : 'normal',
                  color: showTimelineDataOnly ? 'primary.main' : 'text.secondary'
                }}
              >
                Dated Initiatives Only
              </Typography>
            </Box>
          }
          sx={{
            margin: 0,
            '& .MuiFormControlLabel-label': {
              fontSize: '0.8rem'
            }
          }}
        />
      </Tooltip>
    </Box>
  )
}

export default TimelineDataToggle
